import React from "react";
import "../styles/cookies.scss";

function Cookies() {
  return (
    <>
      <div className="cookies-parent parent">
        <div className="cookies cont">
          <h1>Privacy Policy for The Indian Journey</h1>

          <p>
            <span className="suggest-text">Last Updated On :</span> 24-Apr-2023
          </p>
          <p>
            <span className="suggest-text">Effective Date :</span> 24-Apr-2023
          </p>

          <p>
            This Privacy Policy describes the policies of Diwise.in, office
            no.214-216, 10 Biz Park, Near Symbiosis Law College, Airport Road,
            Vimannagar, Pune, Maharastra 411014, India, email:
            info@akkafoundation.in, phone: 7666601972 on the collection, use and
            disclosure of your information that we collect when you use our
            website ( https://akkafoundation.in ). (the “Service”). By accessing
            or using the Service, you are consenting to the collection, use and
            disclosure of your information in accordance with this Privacy
            Policy. If you do not consent to the same, please do not access or
            use the Service. We may modify this Privacy Policy at any time
            without any prior notice to you and will post the revised Privacy
            Policy on the Service. The revised Policy will be effective 180 days
            from when the revised Policy is posted in the Service and your
            continued access or use of the Service after such time will
            constitute your acceptance of the revised Privacy Policy. We
            therefore recommend that you periodically review this page.
          </p>
          <p>
            <span className="suggest-text">How We Use Your Information:</span>{" "}
            We will use the information that we collect about you for the
            following purposes:
          </p>

          <p>
            Testimonials
            <br />
            Support
            <br />
            Site protection
          </p>
          <p>
            If we want to use your information for any other purpose, we will
            ask you for consent and will use your information only on receiving
            your consent and then, only for the purpose(s) for which grant
            consent unless we are required to do otherwise by law.
          </p>

          <p>
            <span className="suggest-text">How We Share Your Information:</span>{" "}
            We will not transfer your personal information to any third party
            without seeking your consent, except in limited circumstances as
            described below:
          </p>
          <h3>Analytics</h3>
          <p>
            We require such third party’s to use the personal information we
            transfer to them only for the purpose for which it was transferred
            and not to retain it for longer than is required for fulfilling the
            said purpose.
          </p>
          <p>
            We may also disclose your personal information for the following:
            (1) to comply with applicable law, regulation, court order or other
            legal process; (2) to enforce your agreements with us, including
            this Privacy Policy; or (3) to respond to claims that your use of
            the Service violates any third-party rights. If the Service or our
            company is merged or acquired with another company, your information
            will be one of the assets that is transferred to the new owner.
          </p>

          <h3>Your Rights:</h3>
          <p>
            Depending on the law that applies, you may have a right to access
            and rectify or erase your personal data or receive a copy of your
            personal data, restrict or object to the active processing of your
            data, ask us to share (port) your personal information to another
            entity, withdraw any consent you provided to us to process your
            data, a right to lodge a complaint with a statutory authority and
            such other rights as may be relevant under applicable laws. To
            exercise these rights, you can write to us at
            info@akkafoundation.in. We will respond to your request in
            accordance with applicable law.
          </p>
          <p>
            Do note that if you do not allow us to collect or process the
            required personal information or withdraw the consent to process the
            same for the required purposes, you may not be able to access or use
            the services for which your information was sought.
          </p>

          <h3>Cookies Etc.</h3>
          <p>
            To learn more about how we use these and your choices in relation to
            these tracking technologies, please refer to our Cookie Policy.
          </p>

          <h3>Security:</h3>
          <p>
            The security of your information is important to us and we will use
            reasonable security measures to prevent the loss, misuse or
            unauthorized alteration of your information under our control.
            However, given the inherent risks, we cannot guarantee absolute
            security and consequently, we cannot ensure or warrant the security
            of any information you transmit to us and you do so at your own
            risk.
          </p>

          <h3>Third Party Links & Use Of Your Information:</h3>
          <p>
            Our Service may contain links to other websites that are not
            operated by us. This Privacy Policy does not address the privacy
            policy and other practices of any third parties, including any third
            party operating any website or service that may be accessible via a
            link on the Service. We strongly advise you to review the privacy
            policy of every site you visit. We have no control over and assume
            no responsibility for the content, privacy policies or practices of
            any third party sites or services.
          </p>

          <h3>Grievance / Data Protection Officer:</h3>
          <p>
            If you have any queries or concerns about the processing of your
            information that is available with us, you may email our Grievance
            Officer at diwise.in, office no.214-216, 10 Biz Park, Near Symbiosis
            Law College, Airport Road, Vimannagar, Pune, email:
            info@akkafoundation.in. We will address your concerns in accordance
            with applicable law.
          </p>
        </div>
      </div>
    </>
  );
}

export default Cookies;
